import React, { useEffect } from "react";
import { LanguageContext } from "../Context/LanguageContext";
import { useContext } from "react";
import ServiceIcon from "../components/ServiceIcon";
import SectionHeader from "../components/SectionHeader";

import brand1 from "../assets/icons/brand1.png";
import appicon from "../assets/Logo.png";

import AOS from "aos";
import "aos/dist/aos.css";

function Brands() {
  const { texts, language } = useContext(LanguageContext);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false
    });
  }, []);

  return (
    <div
      id="brands"
      className="relative py-20 sm:py-24 lg:py-32 bg-gradient-to-br from-neutral-50 via-white to-primary-50/20 overflow-hidden scroll-mt-20 sm:scroll-mt-24"
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-64 h-64 bg-primary-200 rounded-full opacity-20 blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 -right-32 w-80 h-80 bg-primary-300 rounded-full opacity-20 blur-3xl animate-pulse animation-delay-1000"></div>
        
        {/* Geometric patterns */}
        <div className="absolute top-10 right-1/4 w-20 h-20 border-4 border-primary-200/30 rounded-lg rotate-45 hidden lg:block"></div>
        <div className="absolute bottom-20 left-1/3 w-16 h-16 border-4 border-primary-300/30 rounded-full hidden lg:block"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 sm:pt-12">
        {/* Enhanced Section Header */}
        <SectionHeader
          badgeText={texts.badge_our_brands}
          badgeIcon={
            <svg className="w-4 h-4 text-primary-600" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
          }
          title={texts.brands}
          titleAs="h2"
          subtitle={texts.brands_subtitle}
          titleClassName="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-3 sm:mb-4 md:mb-5"
          decorativeLineClassName="mb-4"
        />

        {/* Enhanced Brands Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 max-w-5xl mx-auto">
          <div 
            data-aos="fade-up" 
            data-aos-delay="500"
            data-aos-duration="800"
            className="group"
          >
            <ServiceIcon
              text={"Nma Clothes Company Brand"}
              icon={brand1}
              link={"https://linktr.ee/kutali_nma"}
            />
          </div>

          <div 
            data-aos="fade-up" 
            data-aos-delay="600"
            data-aos-duration="800"
            className="group"
          >
            <ServiceIcon
              text={"GARO COMPANY"}
              icon={appicon}
              link={"https://linktr.ee/garo.company"}
            />
          </div>
        </div>

        {/* Enhanced features section */}
        <div 
          className="mt-16 sm:mt-20 lg:mt-24 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8"
          data-aos="fade-up"
          data-aos-delay="800"
        >
          {/* Feature 1 */}
          <div className="group relative bg-white rounded-2xl p-6 shadow-soft hover:shadow-large transition-all duration-300 border border-neutral-100 hover:border-primary-200 overflow-hidden">
            <div className={`absolute top-0 ${language === 'ar' ? 'left-0 rounded-br-full' : 'right-0 rounded-bl-full'} w-20 h-20 bg-primary-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0`}></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-neutral-900 font-bold text-lg mb-2">{texts.feature_quality_assured_title}</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{texts.feature_quality_assured_subtitle}</p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="group relative bg-white rounded-2xl p-6 shadow-soft hover:shadow-large transition-all duration-300 border border-neutral-100 hover:border-primary-200 overflow-hidden">
            <div className={`absolute top-0 ${language === 'ar' ? 'left-0 rounded-br-full' : 'right-0 rounded-bl-full'} w-20 h-20 bg-primary-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0`}></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                </svg>
              </div>
              <h3 className="text-neutral-900 font-bold text-lg mb-2">{texts.feature_wide_selection_title}</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{texts.feature_wide_selection_subtitle}</p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="group relative bg-white rounded-2xl p-6 shadow-soft hover:shadow-large transition-all duration-300 border border-neutral-100 hover:border-primary-200 overflow-hidden">
            <div className={`absolute top-0 ${language === 'ar' ? 'left-0 rounded-br-full' : 'right-0 rounded-bl-full'} w-20 h-20 bg-primary-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-0`}></div>
            <div className="relative z-10">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-400 to-primary-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-neutral-900 font-bold text-lg mb-2">{texts.feature_customer_first_title}</h3>
              <p className="text-neutral-600 text-sm leading-relaxed">{texts.feature_customer_first_subtitle}</p>
            </div>
          </div>
        </div>

        {/* Enhanced Decorative elements */}
        <div className="absolute top-32 left-4 w-24 h-24 bg-primary-200 rounded-2xl opacity-20 rotate-12 hidden xl:block" data-aos="fade-right" data-aos-delay="1000"></div>
        {/* <div className="absolute bottom-24 right-8 w-20 h-20 bg-primary-300 rounded-full opacity-30 hidden xl:block" data-aos="fade-left" data-aos-delay="1200"></div> */}
      </div>
    </div>
  );
}

export default Brands;
